import { selectAuthReady } from "@onmo/auth";
import { ErrorHandling } from "@onmo/ui";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import { Snackbar } from "../components/core/Snackbar/Snackbar";
import { AppReloadPrompt } from "../components/common/AppReloadPrompt/AppReloadPrompt";
import { useEffect } from "react";
import { cache } from "../models/pwa";
import { setManifest } from "../models/manifest";
import { useAppSelector } from "../components/hooks";

export const RootLayout = () => {
  const isOnline = useOnlineStatus();
  const authReady = useAppSelector(selectAuthReady);

  useEffect(() => {
    const onBeforeinstallprompt = (event: any) => {
      event.preventDefault();
      cache[`${window.location.protocol}//${window.location.host}/`] = event;
    };
    window.addEventListener("beforeinstallprompt", onBeforeinstallprompt);

    setManifest(
      import.meta.env.VITE_APP_NAME,
      `${window.location.protocol}//${window.location.host}/`,
    );

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeinstallprompt);
    };
  }, []);

  if (!isOnline) return <ErrorHandling type="network" />;
  if (!authReady) return <GamingLoading />;

  return (
    <>
      <ScrollRestoration />
      <Snackbar />
      <AppReloadPrompt />
      <Outlet />
    </>
  );
};
